<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
import addClientEvent from "./utils/addClientEvent";
import '@/assets/sass/basic.scss';

var audioPlay;
export default {
  name: "App",
  data() {
    return {
      isaudiofrist: 0
    };
  },
  beforeCreate () {
    MiguplayUtils.activityClientEvent.recordEventAction({
      eventType: "code_download",
      rese8: "页面代码下载完成",
    });

    const isPc = /\/pc/.test(window.location.href);
    const isFissionActivity = /\/fissionActivity/.test(window.location.href);
    const from = MG.utils.getQueryString('from');
    let rese4;
    if (!isPc) {
      rese4 = 1;
    } else if(from === 'client'){
      rese4 = 2;
    } else {
      rese4 = 3;
    }
    // 设置设备号
    addClientEvent.setDeviceId();

  },
  created() {},
  mounted() {

  },
  methods: {
   
  },
};
</script>

<style>

 /* 微信中提示在浏览器中打开 */

html,body, #app{
  width: 100%;
  height: 100%;
}
.wx-modal {
  position: fixed;
  z-index: 99;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: center;
  background: rgba(0, 0, 0, 0.8) url('./assets/img/open2.png') no-repeat center .1rem;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue